export enum GenerateImageType {
  SUM = 'SUM',
  SUBTRACT = 'SUBTRACT',
  AVERAGE = 'AVERAGE',
}
